import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "./auth/AuthContext";
import { useLeopardyGames } from "./hooks/useLeopardyGames";

export default function MyLeopardyGames({
  title = "My Leopardy Games",
  headingLevel = 2,
  layout = "grid",
  style = {},
}) {
  const { user } = useAuth();
  const { hostGames, playerGames, loading, error } = useLeopardyGames(user);

  if (!user) {
    return (
      <section style={{ marginTop: 32, ...style }}>
        <p>Please sign in to manage Leopardy games.</p>
      </section>
    );
  }

  const HeadingTag = headingLevel === 3 ? "h3" : "h2";
  const cardsStyle = layout === "stack"
    ? { display: "flex", flexDirection: "column", gap: 12, marginTop: 12 }
    : { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 16, marginTop: 16 };

  const cardStyle = layout === "stack"
    ? { border: "1px solid #ddd", borderRadius: 10, padding: 12 }
    : { border: "1px solid #e0e0e0", borderRadius: 12, padding: 16 };

  const renderCards = (games, role) => {
    if (loading) return <p style={{ marginTop: 12 }}>Loading…</p>;
    if (!games || games.length === 0) return <p style={{ marginTop: 12 }}>No games yet.</p>;
    return (
      <div style={cardsStyle}>
        {games.map((game) => (
          <div key={game.id} style={{ ...cardStyle, display: "grid", gap: 6 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
              <div style={{ fontWeight: 700 }}>{game.title || game.data?.title || "Leopardy Game"}</div>
              <div style={{ fontSize: 12, opacity: 0.7 }}>ID: {game.id}</div>
            </div>
            <div style={{ fontSize: 13, opacity: 0.85 }}>
              Role: {role}
            </div>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 6 }}>
              <Link to={`/leopardy/${role === "host" ? "host" : "play"}/${game.id}`} style={{ padding: "8px 12px", borderRadius: 8, border: "1px solid #1976d2" }}>
                Open
              </Link>
              <Link to={`/leopardy/view/${game.id}`} style={{ padding: "8px 12px", borderRadius: 8, border: "1px solid #9c27b0", color: "#9c27b0" }}>
                Class view
              </Link>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <section style={{ marginTop: 32, ...style }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
        <HeadingTag style={{ margin: 0 }}>{title}</HeadingTag>
        <Link to="/leopardy/games" style={{ fontSize: 14 }}>Open Leopardy dashboard →</Link>
      </div>

      {error && (
        <div style={{ border: "1px solid #e57373", background: "#ffebee", padding: 12, borderRadius: 8, marginTop: 12 }}>
          {error}
        </div>
      )}

      <div style={{ marginTop: 12, fontWeight: 600 }}>Host</div>
      {renderCards(hostGames, "host")}

      <div style={{ marginTop: 20, fontWeight: 600 }}>Player</div>
      {renderCards(playerGames, "player")}
    </section>
  );
}
